import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
// import required modules
import { Autoplay, Pagination, EffectFade } from "swiper/modules";
import Banner1 from "../../assets/homebanner.png";
import Banner2 from "../../assets/homebanner2.png";
import Banner3 from "../../assets/homebanner3.png";
import Banner4 from "../../assets/homebanner4.png";
import Cloud from "../../assets/icon/could.svg";
import BottomBanner1 from "../../assets/homebottom1.jpg";
import BottomBanner2 from "../../assets/homebottom2.jpg";
import BottomBanner3 from "../../assets/homebottom3.jpg";
import BottomBanner4 from "../../assets/homebottom4.jpg";
import BottomBanner5 from "../../assets/homebottom5.jpg";
import Bgabout from "../../assets/backgroundabout.svg";
import TravelTech from "../../assets/traveltech.png";
import Icon from "../../assets/icon-1.svg";
import FreeRegister from "../../assets/freeregisteration.svg";
import BestPrice from "../../assets/bestprice.png";
import EasyOnline from "../../assets/easyonline.svg";
import SecureOnline from "../../assets/onlinetransaction.svg";
import S24x7 from "../../assets/24X7.svg";
import Review from "../../assets/reviews.svg";
import Hotel from "../../assets/hotel.svg";
import Pathway from "../../assets/pathway.svg";
import User from "../../assets/users.svg";
import UAEFlag from "../../assets/UAE.svg";
import UAEicon from "../../assets/icon/uaeicon.svg";
import Indiaflag from "../../assets/India.svg";
import Indiaicon from "../../assets/icon/Indiaicon.svg";
import OmanFlag from "../../assets/Oman.svg";
import Omanicon from "../../assets/icon/omanicon.svg";
import RussiaFlag from "../../assets/Russia.svg";
import Russiaicon from "../../assets/icon/russiaicon.svg";
import UK from "../../assets/UK.svg";
import UKicon from "../../assets/icon/ukicon.svg";
import Tanzania from "../../assets/Tanzania.svg";
import Tanzaniaicon from "../../assets/icon/tanzaniaicon.svg";
import HongKong from "../../assets/Honk Kong.svg";
import HongKongicon from "../../assets/icon/hongkongicon.svg";
import Image1 from "../../assets/aboutimage1.png";
import Image2 from "../../assets/aboutimage2.png";
import Image3 from "../../assets/aboutimage3.png";
import Playstore from "../../assets/icon/googlepay.svg";
import Appstore from "../../assets/icon/appstore.svg";
import QrCode from "../../assets/icon/qrcode.svg";
import ManTarvel from "../../assets/icon/man-traveling.svg";
import Mobile from "../../assets/icon/mobile.png";

const index = () => {
  return (
    <div>
      <div>
        <Swiper
          pagination={true}
          modules={[Pagination, Autoplay, EffectFade]}
          loop={true}
          autoplay={{
            delay: 5000,
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <div className="flex w-full h-64 md:h-auto">
              <img src={Banner1} alt="fbt-b2b" className="w-full relative" />
              <div className="flex flex-col w-full gap-1 text-left absolute bottom-[30px] left-[3%] md:gap-5 md:w-2/3">
                <h1 className="font-semibold text-white text-lg md:text-[40px] leading-[30px]">
                  Global Travel Solutions Leader
                </h1>
                <p className="text-slate-200 w-11/12 text-xs md:text-lg">
                  Empowering travel partners with a global booking system, the
                  best prices, and extensive inventory to serve customers
                  effortlessly.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex justify-center w-full h-64 md:h-auto">
              <img src={Banner2} alt="fbt-b2b" className="w-full relative" />
              <div className="flex flex-col w-full gap-1 text-left absolute bottom-[30px] left-[3%] md:gap-5 md:w-2/3">
                <h1 className="font-semibold text-white text-lg md:text-[40px] leading-[30px]">
                  Global Travel Solutions Leader
                </h1>
                <p className="text-slate-200 w-11/12 text-xs md:text-lg">
                  Empowering travel partners with a global booking system, the
                  best prices, and extensive inventory to serve customers
                  effortlessly.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex w-full h-64 md:h-auto">
              <img src={Banner3} alt="fbt-b2b" className="w-full relative" />
              <div className="flex flex-col w-full gap-1 text-left absolute bottom-[30px] left-[3%] md:gap-5 md:w-2/3">
                <h1 className="font-semibold text-white text-lg md:text-[40px] leading-[30px]">
                  Global Travel Solutions Leader
                </h1>
                <p className="text-slate-200 w-11/12 text-xs md:text-lg">
                  Empowering travel partners with a global booking system, the
                  best prices, and extensive inventory to serve customers
                  effortlessly.
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="flex w-full h-64 md:h-auto">
              <img src={Banner4} alt="fbt-b2b" className="w-full relative" />
              <div className="flex flex-col w-full gap-1 text-left absolute bottom-[30px] left-[3%] md:gap-5 md:w-2/3">
                <h1 className="font-semibold text-white text-lg md:text-[40px] leading-[30px]">
                  Global Travel Solutions Leader
                </h1>
                <p className="text-slate-200 w-11/12 text-xs md:text-lg">
                  Empowering travel partners with a global booking system, the
                  best prices, and extensive inventory to serve customers
                  effortlessly.
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="container mx-auto my-4 gap-5 p-5 md:p-8 md:my-10 lg:px-15">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          <div className="mx-auto order-last md:order-first lg:mx-0">
            <img src={TravelTech} alt="fbt-b2b" />
          </div>
          <div>
            <span className="flex gap-2 items-baseline justify-start  my-1 text-black">
              <img src={Icon} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-xl md:text-2xl">
                We are a Travel Tech Portal
              </h2>
            </span>
            <h1 className="font-semibold my-3 text-2xl md:text-4xl">
              Welcome to FBT Your B2B Travel Partner
            </h1>
            <p className="font-normal text-sm text-justify sm:text-lg">
              Since our establishment in 2016, FBT Adventures has evolved into a
              leading Destination Management Company in the Middle East. We
              specialize in offering top-notch solutions to our travel partners
              globally,Our experienced and highly qualified team is dedicated to
              providing personalized hospitality and innovative travel
              solutions. Over time, we have gained extensive experience and
              recognition for our personalized approach to hospitality. Today,
              our highly qualified team, hand-picked and trained by myself and
              our experts, is well-known and respected throughout the travel
              industry. We have expanded our services from ground handling to
              include destination wedding planning and ultra-luxury experiences
              across the UAE, OMAN, OMAN, and UK. We are committed to becoming
              the most reliable and reputed DMC Services Provider in this
              region. If you are looking to work with us, my team would be more
              than happy to assist you with additional information.
            </p>
          </div>
        </div>
      </div>
      <div className="sectionbg">
        <div className="container mx-auto my-4 p-5 md:p-8 md:my-10 lg:px-15">
          <div className="flex flex-col gap-3">
            <span className="flex gap-2 items-baseline justify-start md:justify-center my-1 text-black">
              <img src={Icon} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-xl md:text-2xl">
                Why book with us
              </h2>
            </span>
            <h1 className="font-semibold mt-5 mb-5 text-2xl md:text-4xl md:mb-10 md:text-center">
              Simplifying Every Aspect of Your Business
            </h1>
            <div className="grid grid-cols-1 gap-10 md:grid-cols-2 md:gap-16">
              <div className="flex flex-col gap-5 justify-center items-center text-center md:flex-row md:gap-5 md:text-left">
                <img src={FreeRegister} alt="fbtb2b" className="w-14" />
                <div>
                  <h1 className="text-xl font-semibold mb-2">
                    Free & Quick Registration
                  </h1>
                  <p className="text-center md:text-justify">
                    Sign up for free and quickly access all our products,
                    including worldwide properties, sightseeing tours, car
                    rentals, local transfers, cruises, and holiday packages.
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-5 justify-center items-center text-center md:flex-row md:gap-5 md:text-left">
                <img src={BestPrice} alt="fbtb2b" className="w-14" />
                <div>
                  <h1 className="text-xl font-semibold mb-2">
                    Best Price Guarantee
                  </h1>
                  <p className="text-center md:text-justify">
                    FBT offers a Best Price Guarantee, ensuring you get
                    top-quality destination management services and the best
                    value in the industry.
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-5 justify-center items-center text-center md:flex-row md:gap-5 md:text-left">
                <img src={EasyOnline} alt="fbtb2b" className="w-14" />
                <div>
                  <h1 className="text-xl font-semibold mb-2">
                    Easy Online Transaction
                  </h1>
                  <p className="text-center md:text-justify">
                    At FBT, we focus on keeping your personal data safe. Our
                    online portal is fully protected with the latest security
                    measures. Your privacy is our priority.
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-5 justify-center items-center text-center md:flex-row md:gap-5 md:text-left">
                <img src={SecureOnline} alt="fbtb2b" className="w-14" />
                <div>
                  <h1 className="text-xl font-semibold mb-2">
                    Secure Online Transaction
                  </h1>
                  <p className="text-center md:text-justify">
                    Our online payment system is safe and secure! It encrypts
                    your payment details to guard against fraud and unauthorized
                    use.
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-5 justify-center items-center text-center md:flex-row md:gap-5 md:text-left">
                <img src={S24x7} alt="fbtb2b" className="w-14" />
                <div>
                  <h1 className="text-xl font-semibold mb-2">
                    24X7 Live Chat Support
                  </h1>
                  <p className="text-center md:text-justify">
                    We offer award-winning customer support available 24/7
                    through Live Chat and WhatsApp. Whether you have questions
                    about our services, need help with bookings, or want advice
                    on your next holiday, our team is here to assist you
                    anytime, anywhere.
                  </p>
                </div>
              </div>
              <div className="flex flex-col gap-5 justify-center items-center text-center md:flex-row md:gap-5 md:text-left">
                <img src={Review} alt="fbtb2b" className="w-14" />
                <div className="flex flex-col ">
                  <h1 className="text-xl font-semibold mb-2">
                    Guest Reviews & Ratings
                  </h1>
                  <p className="text-center md:text-justify">
                    At FBT, we're proud of our ability to provide personalized
                    destination management services that truly impress our
                    customers. Don’t just take our word for it—visit our
                    Testimonials Page to see what our guests have to say about
                    their booking and travel experiences with us.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="container mx-auto grid grid-cols-1 gap-10 lg:grid-cols-3 my-4 p-5 md:p-8 md:my-10 lg:px-15">
          <div className="block md:hidden">
            <Swiper
              pagination={true}
              modules={[Pagination, Autoplay, EffectFade]}
              loop={true}
              autoplay={{
                delay: 5000,
              }}
              className="mySwiper"
            >
              <SwiperSlide>
                <div className="flex gap-2 flex-col items-center pb-6 p-3">
                  <span className="flex gap-2 items-center justify-center my-1 text-black">
                    <img src={Image1} alt="fbt-b2b" />
                  </span>
                  <span className="flex gap-2 items-baseline justify-center my-1 font-primary">
                    <img src={Pathway} alt="fbt-b2b" />
                    <h2 className="font-primary font-bold text-2xl">10000+</h2>
                  </span>
                  <p className="text-center font-bold text-base font-[#000929]">
                    Sightseeing items and Tours Covering 500 cities
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="flex gap-2 flex-col items-center pb-6 p-3">
                  <span className="flex gap-2 items-center justify-center my-1 text-black">
                    <img src={Image2} alt="fbt-b2b" />
                  </span>
                  <span className="flex gap-2 items-baseline justify-center my-1 font-primary">
                    <img src={Hotel} alt="fbt-b2b" />
                    <h2 className="font-primary font-bold text-2xl">
                      640,000+
                    </h2>
                  </span>
                  <p className="text-center font-bold text-base font-[#000929]">
                    Hotels & Apartments Worldwide
                  </p>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="flex gap-2 flex-col items-center pb-6 p-3">
                  <span className="flex gap-2 items-center justify-center my-1 text-black">
                    <img src={Image3} alt="fbt-b2b" />
                  </span>
                  <span className="flex gap-2 items-baseline justify-center my-1 font-primary">
                    <img src={User} alt="fbt-b2b" />
                    <h2 className="font-primary font-bold text-2xl">10000+</h2>
                  </span>
                  <p className="text-center w-3/4 font-bold text-base font-[#000929]">
                    Our Active User's All over the world
                  </p>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <div className="gap-2 flex-col items-center p-3 hidden md:flex">
            <div class="hover01 column">
              <div>
                <figure>
                  <span className="flex gap-2 items-center justify-center my-1">
                    <img src={Image1} alt="fbt-b2b" />
                  </span>
                </figure>
              </div>
            </div>
            <span className="flex gap-2 items-baseline justify-center my-1 font-primary">
              <img src={Pathway} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-2xl">10000+</h2>
            </span>
            <p className="text-center font-bold text-base font-[#000929]">
              Sightseeing items and Tours Covering 500 cities
            </p>
          </div>
          <div className="gap-2 flex-col items-center p-3 hidden md:flex">
            <div class="hover01 column">
              <div>
                <figure>
                  <span className="flex gap-2 items-center justify-center my-1">
                    <img src={Image2} alt="fbt-b2b" />
                  </span>
                </figure>
              </div>
            </div>
            <span className="flex gap-2 items-baseline justify-center my-1 font-primary">
              <img src={Hotel} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-2xl">640,000+</h2>
            </span>
            <p className="text-center font-bold text-base font-[#000929]">
              Hotels & Apartments Worldwide
            </p>
          </div>

          <div className="gap-2 flex-col items-center p-3 hidden md:flex">
            <div class="hover01 column">
              <div>
                <figure>
                  <span className="flex gap-2 items-center justify-center my-1">
                    <img src={Image3} alt="fbt-b2b" />
                  </span>
                </figure>
              </div>
            </div>
            <span className="flex gap-2 items-baseline justify-center my-1 font-primary">
              <img src={User} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-2xl">10000+</h2>
            </span>
            <p className="text-center w-3/4 font-bold text-base font-[#000929]">
              Our Active User's All over the world
            </p>
          </div>
        </div>
      </div>
      <div
        className="sectionbg"
        style={{
          backgroundImage: `url(${Bgabout})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
        }}
      >
        <div className="container mx-auto gap-10 py-10 px-5 md:p-8 lg:px-15">
          <div>
            <span className="flex gap-2 items-baseline justify-center my-1 text-black">
              <img src={Icon} alt="fbt-b2b" />
              <h2 className="font-primary font-bold text-2xl">There for You</h2>
            </span>
            <h1 className="font-semibold text-center mt-5 text mb-5 text-3xl sm:text-4xl">
              Our DMC Presence
            </h1>
            <div className="flex flex-wrap justify-center gap-10 py-10  px-5 md:px-8 lg:px-15 lg:grid-cols-3">
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={Indiaflag}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={Indiaicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          India
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img src={UAEFlag} alt="fbt-b2b" className="border-2" />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={UAEicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          Dubai
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img src={UK} alt="fbt-b2b" className="border-2" />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={UKicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          United Kingdom
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={RussiaFlag}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={Russiaicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          Russia
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={OmanFlag}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={Omanicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">Oman</h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={Tanzania}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={Tanzaniaicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          Tanzania
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
              <div class="hover01 column">
                <div>
                  <figure>
                    <div className="flex gap-2 flex-col items-center bg-white p-3 shadow-inner rounded-xl">
                      <span className="flex gap-2 items-center justify-center my-1 text-black">
                        <img
                          src={HongKong}
                          alt="fbt-b2b"
                          className="border-2"
                        />
                      </span>
                      <span className="flex gap-2 items-center justify-center my-1 font-primary">
                        <img src={HongKongicon} alt="fbt-b2b" />
                        <h2 className="font-primary font-bold text-xl">
                          Hong Kong
                        </h2>
                      </span>
                    </div>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto gap-10 py-10 px-5 md:p-8 lg:px-15">
        <Swiper
          pagination={true}
          modules={[Pagination, Autoplay, EffectFade]}
          loop={true}
          autoplay={{
            delay: 5000,
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <img src={BottomBanner1} alt="fbt-b2b" className="w-full" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={BottomBanner2} alt="fbt-b2b" className="w-full" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={BottomBanner3} alt="fbt-b2b" className="w-full" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={BottomBanner4} alt="fbt-b2b" className="w-full" />
          </SwiperSlide>
          <SwiperSlide>
            <img src={BottomBanner5} alt="fbt-b2b" className="w-full" />
          </SwiperSlide>
        </Swiper>
      </div>
      <div className="sectionbg relative my-0 md:my-10">
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[5%] left-[50%]"
        />
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[12%] left-[30%]"
        />
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[2%] left-[10%]"
        />
        <img
          src={Cloud}
          alt="fbtb2b"
          className="absolute top-[5%] left-[80%] hidden md:block"
        />
        <div className="container mx-auto p-5 md:p-8 lg:px-15">
          <div className="py-10 flex flex-col justify-between lg:flex-row">
            <div className="w-full flex flex-col gap-1 lg:w-2/5">
              <div className="font-semibold font-primary text-base mb-3 text-center md:text-left">
                Get all your trip detail in our Mobile App
              </div>
              <div className="font-semibold font-primary text-3xl mb-3 text-center md:text-left">
                <span className="text-[rgb(24,119,242)]">
                  Journey<span className="text-[#e51e25]">X</span>
                </span>{" "}
                the one stop destination for all your trip worries
              </div>
              <div className="flex flex-wrap flex-col items-center justify-center gap-5 my-5 sm:flex-row md:justify-start">
                <div class="hover01 column">
                  <div>
                    <figure>
                      <img
                        src={Appstore}
                        className="max-w-48 w-full"
                        alt="fbt-b2b"
                      />
                    </figure>
                  </div>
                </div>
                <div class="hover01 column">
                  <div>
                    <figure>
                      <img
                        src={Playstore}
                        className="max-w-48 w-full"
                        alt="fbt-b2b"
                      />
                    </figure>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-center gap-5 my-5 justify-center md:justify-start md:flex-row">
                <img src={QrCode} alt="fbt-b2b" />
                <div className="font-semibold font-primary text-lg mb-3 text-center md:text-left ">
                  Scan the QR code to install JourneyX Mobile App
                </div>
              </div>
            </div>

            <div className="relative flex w-full lg:w-[60%] justify-center pt-10 md:justify-end lg:pt-0">
              <img
                src={ManTarvel}
                alt="fbt-b2b"
                className="absolute z-10 left-[-120px] top-[15%] hidden md:block"
              />
              <div className="relative">
                <img
                  src={Mobile}
                  alt="fbt-b2b"
                  className="max-w-[529px] w-full"
                />
                {/* <img src={Shadow} alt="fbt-b2b" className="absolute bottom-[-20%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 hidden md:block lg:bottom-[-5%]"/> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default index;
